<template>
  <Modal v-model="isShow" width="45%" :closable="false" :mask-closable="false">
    <div slot="header" class="info-header">
      <div class="ivu-modal-header-inner">修改密码</div>
    </div>
    <div>
      <Form ref="userForm" :model="form" :label-width="80" :rules="ruleValidate">
        <Row>
          <Col span="12">
            <FormItem label="账户">
              <Input v-model="form.account" placeholder="13112345678" :disabled="disable"></Input>
            </FormItem>
          </Col>
          <Col span="12">
            <FormItem label="用户">
              <Input v-model="form.name" placeholder="张三" :disabled="disable"></Input>
            </FormItem>
          </Col>
        </Row>
        <Row>
          <Col span="24">
            <FormItem label="原密码" prop="oldPassword">
              <Input v-model="form.oldPassword" placeholder="原密码" type="password" width="400px"></Input>
            </FormItem>
          </Col>
        </Row>
        <Row>
          <Col span="12">
            <FormItem label="新密码" prop="newPassword">
              <Input v-model="form.newPassword" placeholder="8位以上数字和字母" type="password"></Input>
            </FormItem>
          </Col>
          <Col span="12">
            <FormItem label="密码确认" prop="newAgainPwd">
              <Input v-model="form.newAgainPwd" placeholder="8位以上数字和字母" type="password"></Input>
            </FormItem>
          </Col>
        </Row>
      </Form>
    </div>
    <div slot="footer">
      <Button type="primary" @click="submit">确认修改</Button>
    </div>
  </Modal>
</template>

<script>

import md5 from 'js-md5'
export default {
  name: 'user-passwd',
  data () {
    return {
      form: { newPassword: '', newAgainPwd: '', oldPassword: '' },
      isShow: false,
      type: 'add',
      disable: false,
      passwordDisable: false,
      ruleValidate: {
        id: [
          { required: true, message: '客户信息不允许为空', trigger: 'blur' }
        ],
        oldPassword: [
          { required: true, message: '原密码不允许为空', trigger: 'blur' }
        ],
        newPassword: [
          { required: true,
            message: '密码强度不够',
            trigger: 'blur',
            validator (rule, value, callback) {
              return /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{6,}$/.test(value)
            } }
        ],
        newAgainPwd: [
          { required: true,
            message: '密码强度不够',
            trigger: 'blur',
            validator (rule, value, callback) {
              return /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{6,}$/.test(value)
            } }
        ]
      },
      roles: [],
      roleList: [],
      deptOptions: [],
      normalizer (node) {
        return {
          id: node.id,
          label: node.fullName
        }
      }
    }
  },
  methods: {
    openModel (type, data) {
      this.isShow = true
      this.type = type
      if (data) {
        this.form = data
        this.form.sex = this.form.sex + ''
      } else {
        this.form = {}
      }
      this.disable = type === 'detail'
      this.passwordDisable = type !== 'detail'
    },
    closeModel () {
      this.isShow = false
    },
    submit () {
      if (this.form.newPassword !== this.form.newAgainPwd) {
        this.form.newAgainPwd = ''
      }
      this.$refs.userForm.validate((valid) => {
        if (valid) {
          let param = {
            account: this.form.account,
            type: 1, // 管理平台账户
            password: md5(this.form.newPassword),
            oldPassword: md5(this.form.oldPassword)
          }
          this.P('admin/userAuth/modifyPassword', param).then(data => {
            this.isShow = false
            this.$Message.success('密码修改成功')
          })
        } else {
          this.$Message.error('请检查填写的数据')
        }
      })
    }
  }
}
</script>
